/* Tysk katalog for locale-advisor-plan-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'adv.plan.viewForecast': 'Prognose ansehen',
  'adv.plan.forecastTitle': 'Cashflow mit geplanten Ereignissen',
  'adv.plan.forecastIntro': 'Vergleiche den Saldo auf Basis der gebuchten Zahlen mit dem Saldo nach den Ereignissen, die du erfasst hast.',
  'adv.plan.forecastWithoutEvents': 'Ohne geplante Ereignisse',
  'adv.plan.forecastWithEvents': 'Mit geplanten Ereignissen',
  'adv.plan.forecastChange': 'Veränderung zum Jahresende',
  'adv.plan.forecastScope': 'Geplante Ereignisse ändern nur die Prognose, nicht die Buchhaltung oder das Budget. Der Saldo stoppt in der Kurve bei null, daher kann die Veränderung zum Jahresende kleiner sein als die Summe der Ereignisse.',
  'adv.plan.showVariance': 'Abweichungen anzeigen',
  'adv.plan.hideVariance': 'Abweichungen ausblenden',
});
